module.exports = __webpack_public_path__ + "static/media/Twitter-Icon--inverse.9587743f.svg";